import { http } from "@/utils/http";
import { AxiosResponse } from "axios";
import {
  INewShiftTemplate,
  IShiftTemplate,
  IUpdateShiftTemplate,
} from "@/features/shifts/shifts.types";

export const shiftService = {
  getShifts(isActive?: boolean): Promise<AxiosResponse> {
    if (isActive !== undefined) {
      return http.get<IShiftTemplate[]>(
        `/shifts/templates?is_active=${isActive}`
      );
    } else {
      return http.get<IShiftTemplate[]>("/shifts/templates");
    }
  },

  createShift(payload: INewShiftTemplate): Promise<AxiosResponse> {
    return http.post("/shifts/templates", payload);
  },

  updateShift(
    shiftId: string,
    payload: IUpdateShiftTemplate
  ): Promise<AxiosResponse> {
    return http.patch(`/shifts/templates/${shiftId}`, payload);
  },

  currentShift(): Promise<AxiosResponse> {
    return http.post("/shifts/runs/ensure-current");
  },

  runsShift(run_date: string): Promise<AxiosResponse> {
    return http.get(`/shifts/runs?run_date=${run_date}`);
  },

  seedDefaultShift(): Promise<AxiosResponse> {
    return http.post("/shifts/templates/seed-default");
  },

  addShiftMember(shiftRunId: string, userId: string): Promise<AxiosResponse> {
    return http.post(`/shifts/runs/${shiftRunId}/members?user_id=${userId}`);
  },
};
